import React from 'react'
import { sizes } from './const'

export interface ProfileIconProps {
    /**
     * This allows to pass a custom className to the component.
     * i.e. className="js_ProfileIcon", which is used for Google Analytics.
     *
     * Note: className overrides equivalent styles for size and fill
     *
     */
    className?: string
    /**
     * The size we can use for the icon: small, medium, large.
     * small = 16px, medium = 24px, large = 32px.
     *
     */
    size?: 'small' | 'medium' | 'large'

    /**
     * The color of the icon
     * */
    fill?: 'white' | 'black'
}

export const ProfileIcon = ({
    className = 'fill-black',
    size = 'medium',
    fill = 'white',
}: ProfileIconProps) => {
    return (
        <svg
            className={`js_ProfileIcon ${sizes[size]} ${className}`}
            viewBox="0 0 24 24"
            fill={fill}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2672_10415)">
                <path
                    d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
                    stroke="#111827"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
                    stroke="#111827"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    )
}
